import DaoImage from "./assets/dao.png";
import StarsImage from "./assets/stars.png";
import NftImage from "./assets/nft-defi.png";
import Web3Image from "./assets/web3.png";

export const OffsetType = {
  LEFT: "left",
  RIGHT: "right",
};

export const expectationList = [
  {
    id: "e3fc3f9c-e550-415d-8d72-2b671e2530a5",
    title: "Токен",
    description: `Каждый новый учащийся автоматически получает NFT-пасс Guide DAO — закрытого сообщества крипто-энтузиастов и разработчиков с единой казной и совместным гаверненсом.`,
    imageUrl: DaoImage,
  },
  {
    id: "5f4117d0-8d50-4e53-85b1-9302b1283493",
    title: "Лаборатория",
    description: `Новички и «суперкодеры» бок о бок занимаются заказной разработкой и берут баг-баунти, помогая известным web3-протоколам и пополняя свое портфолио реальными проектами.`,
    imageUrl: StarsImage,
    offset: OffsetType.LEFT,
  },
  {
    id: "7a49b328-2415-4646-b743-a627778742c8",
    title: "Комьюнити",
    description: `В нашем дискорде зависают в рабочее время, «раздувают» в 4 утра и делятся альфой. В окружении одержимых криптой и всегда готовых прийти на помощь дегенов учиться 10х продуктивнее, чем соло.`,
    imageUrl: NftImage,
    offset: OffsetType.RIGHT,
  },
  {
    id: "63ab08d1-1dc7-4751-9949-aebf2e16b98f",
    title: "Платформа",
    description: `Своя LMS, заточенная на изучение кода. Смотрите видео или читайте статьи, а знания закрепляйте на точечных практиках и «умных» тестах. Получайте токены за ачивки и NFT-дипломы по окончании.`,
    imageUrl: Web3Image,
  },
];
